module.exports = __webpack_public_path__ + "static/icon-experienced-627467e61eb0a037ab4200e3d807d572.png";